"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var News = function News(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M7.006 18.881a1.875 1.875 0 01-1.875-1.875V5.444c0-.173.28-.313.625-.313.346 0 .625.14.625.313s.28.313.625.313c.346 0 .625-.14.625-.313s.28-.313.626-.313c.345 0 .625.14.625.313s.28.313.625.313.625-.14.625-.313.28-.313.625-.313.625.14.625.313.28.313.625.313.625-.14.625-.313.28-.313.625-.313.625.14.625.313.28.313.625.313.625-.14.625-.313.28-.313.625-.313.624.14.624.313.28.313.625.313c.346 0 .625-.14.625-.313s.28-.313.625-.313c.346 0 .625.14.625.313v11.563c0 1.035-.839 1.874-1.875 1.874h-10zm.313-6.874a.312.312 0 00-.313.312v3.75c0 .173.14.313.313.313h3.125c.173 0 .313-.14.313-.313v-3.75a.312.312 0 00-.313-.313H7.319zm8.438-3.438a.312.312 0 00-.313-.313H8.569a.313.313 0 00-.313.313v.625c0 .173.14.313.313.313h6.875c.173 0 .313-.14.313-.313v-.625zm.937 3.438h-4.375a.312.312 0 100 .625h4.375a.312.312 0 100-.625zm0 1.875h-4.375a.312.312 0 100 .625h4.375a.312.312 0 100-.625zm0 1.875h-4.375a.312.312 0 100 .624h4.375a.312.312 0 100-.624z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(News);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(News, "News", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/News.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/News.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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